import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import keymaster from 'keymaster';
import { Modal } from 'react-bootstrap';

require.ensure([], () => {  
    require('./Material-Design-Iconic.less');
});

class DeleteConfirmationModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        ReactDOM.findDOMNode(this.refs.confirmButton).focus();
        keymaster.unbind('left');
        keymaster.unbind('right');
        keymaster('left', this.selectNextButton);
        keymaster('right', this.selectNextButton);
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
        this.props.returnKeymaster();
    }

    handleConfirm = () => {
        this.props.handleConfirm();
        this.handleClose();
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.confirmButton).focus();
    }

    // OTHER METHODS

    selectNextButton = () => {
        ReactDOM.findDOMNode(this.refs.confirmButton) === document.activeElement
        ? ReactDOM.findDOMNode(this.refs.closeButton).focus()
        : ReactDOM.findDOMNode(this.refs.confirmButton).focus();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Confirm delete</h4>
                        </div>
                        <div className="modal-body text-center">
                            <div className="row">
                                This action will delete all work logs from this day.
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" ref="confirmButton"  onClick={this.handleConfirm} className="btn btn-default btn-discrete">Yes</button>
                            <button type="button" ref="closeButton" onBlur={this.handleRefocus} onClick={this.handleClose} className="btn btn-default btn-discrete">No</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

DeleteConfirmationModal.propTypes = {
    returnKeymaster: PropTypes.func,
    handleClose: PropTypes.func,
    handleConfirm: PropTypes.func
};

export default connect()(DeleteConfirmationModal);


/** WEBPACK FOOTER **
 ** ./src/app/components/DeleteConfirmationModal.js
 **/